<template>
    <modal-side-generic
    showFooter
    :title=selectedBeneficiary.name
    :buttonsFooterData="buttonsFooterData"
    @hideMe="emit('hideMe')">
        <div v-for="(lineGroup, index) in beneficiariesDetailArray" :key="`lineGroup${lineGroup.index}`" class="group-wrapper">
            <divider-generic :icon="lineGroup.icon" :title="lineGroup.label" :applyBorder="index !== 0"/>
            <!-- Text Block for each line -->
            <text-block-generic
            v-for="(line, index) in lineGroup.lines"
            applyEllipsis
            :key="`lineGroupLine${line,index}`"
            :params="line"
            :icon="line.icon"
            :colorIconPreset="line.colorIconPreset"
            :mask="line.mask"/>
        </div>
    </modal-side-generic>
</template>

<script setup>
import ModalSideGeneric from '@/components/generic/modals/side/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue & Helpers */
import { computed } from 'vue'
import { getDate } from '@/assets/scripts/dateBuilders'
import { ACCOUNTS_NIB_IBAN_GENERIC, PHONE_NUMBER } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe', 'deleteBeneficiary', 'redirectToEditFeature'])

const props = defineProps({
    selectedBeneficiary: Array
})

const beneficiariesDetailArray = computed(() => {
    return [
        {
            label: t('transfers.beneficiaries.beneficiariesDetailArray.data'),
            icon: 'person',
            lines: [{
                label: t('transfers.beneficiaries.beneficiariesDetailArray.name'),
                content: props.selectedBeneficiary.name
            },
            {
                label: t('transfers.beneficiaries.beneficiariesDetailArray.genericDestination'),
                content: props.selectedBeneficiary.genericDestination ? props.selectedBeneficiary.genericDestination : '-',
                mask: props.selectedBeneficiary.genericDestination ? ACCOUNTS_NIB_IBAN_GENERIC : null
            },
            {
                label: t('transfers.beneficiaries.beneficiariesDetailArray.phoneNumber'),
                content: props.selectedBeneficiary.phoneNumber ? props.selectedBeneficiary.phoneNumber : '-',
                mask: props.selectedBeneficiary.phoneNumber ? PHONE_NUMBER : null
            },
            {
                label: t('transfers.beneficiaries.beneficiariesDetailArray.email'),
                content: props.selectedBeneficiary.email ? props.selectedBeneficiary.email : '-'
            },
            {
                label: t('transfers.beneficiaries.beneficiariesDetailArray.address'),
                content: props.selectedBeneficiary.address ? props.selectedBeneficiary.address : '-'
            }]
        },
        {
            label: t('transfers.beneficiaries.beneficiariesDetailArray.creationDate'),
            icon: 'calendar',
            lines: [{
                label: t('transfers.beneficiaries.beneficiariesDetailArray.date'),
                content: getDate(props.selectedBeneficiary.creationDate),
                classes: 'capitalize'
            }]
        }
    ]
})

const buttonsFooterData = [{
    label: t('transfers.beneficiaries.beneficiariesDetailArray.buttonsFooterData.delete'),
    buttonPosition: 'left',
    buttonType: 'negative',
    icon: 'delete',
	callbackFunction: () => { emit('deleteBeneficiary') }
}, {
	label: t('transfers.beneficiaries.beneficiariesDetailArray.buttonsFooterData.edit'),
	secondVariant: false,
    icon: 'pencil',
    iconPosition: 'right',
    buttonPosition: 'right',
    buttonType: 'primary',
	callbackFunction: () => { emit('redirectToEditFeature', props.selectedBeneficiary) }
}]
</script>
